import * as React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import { GetQuery } from './Shared';

const JobReportViewerData = () => {
    const [loading, setLoading] = React.useState(false);
    const { name, id, param1 } = useParams();

    React.useEffect(() => {

        if (name != "") {
            getData();
        }
    }, []);

    const getData = async () => {
        const baseURL = window.location.origin;
        var urlString = "Get" + name + "Data?jobId=" + id + "&reportName=" + name;
        if (param1 && Number(param1) > 0) {
            urlString += "&param1=" + param1;
        }
        var result = await GetQuery(urlString);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                if (result.data.isError) {
                    var errors = result.data.messages as any[];
                    errors.map(function (error: any) {
                        toast.error(error.content);
                    });
                } else {
                    setLoading(false);

                    var options = new Stimulsoft.Viewer.StiViewerOptions();
                    var viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
                    var report = new Stimulsoft.Report.StiReport();
                    var reportFile = Stimulsoft.System.IO.File.getFile(baseURL + "/reports/" + result.data.reportFileName);
                    report.load(reportFile);

                    var reportData = JSON.stringify(result.data.reportData);
                    //Dataset created
                    var dataSet = new Stimulsoft.System.Data.DataSet("data");
                    dataSet.readJson(reportData)
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.reportName = result.data.reportName;
                    report.dictionary.connect(false);
                    report.dictionary.synchronize();

                    //add relationships between data
                    for (var i = 0; i < result.data.reportRelationships.length; i++) {
                        var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(result.data.reportRelationships[i].sourceName, result.data.reportRelationships[i].name, result.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(result.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(result.data.reportRelationships[i].childTableName), [result.data.reportRelationships[i].parentFieldName], [result.data.reportRelationships[i].childFieldName]);
                        report.dictionary.relations.add(dataRelation);
                        report.dictionary.synchronize();
                    }

                    viewer.report = report;
                    viewer.renderHtml('viewer');
                }
            }
        }
    }

    const renderDetails = (
        <div id="viewer"></div>
    );


    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default JobReportViewerData;